import React from 'react';
import { CitationDisplay } from './CitationDisplay';
import { CitationParser } from '../utils/citationParser';

export const MessageItem = ({ message, apiBaseUrl }) => {
  const isUser = message.role === 'user';
  const timestamp = new Date(message.timestamp).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
  
  // Parse citations from message content
  const citationMatches = CitationParser.parseCitations(message.content);
  const citations = CitationParser.convertToCitations(citationMatches);
  const cleanContent = CitationParser.removeCitationTags(message.content);
  
  // Also check for legacy citations format
  const hasCitations = (message.citations && message.citations.length > 0) || citations.length > 0;
  const displayCitations = citations.length > 0 ? citations : message.citations || [];
  
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-3xl p-4 rounded-lg shadow-sm ${
        isUser 
          ? 'bg-blue-600 text-white ml-12' 
          : 'bg-white text-gray-800 mr-12 border'
      }`}>
        {/* Avatar */}
        {!isUser && (
          <div className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
            </div>
            <div className="flex-1">
              <div className="whitespace-pre-wrap break-words">{cleanContent || message.content}</div>
              
              {/* Citations */}
              {hasCitations && (
                <CitationDisplay citations={displayCitations} apiBaseUrl={apiBaseUrl} />
              )}
              
              <div className="text-xs text-gray-500 mt-2">{timestamp}</div>
            </div>
          </div>
        )}
        
        {/* User message */}
        {isUser && (
          <div className="flex items-start space-x-3">
            <div className="flex-1">
              <div className="whitespace-pre-wrap break-words">{message.content}</div>
              <div className="text-xs text-blue-100 mt-2">{timestamp}</div>
            </div>
            <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
